import { SpriteSheetLoader } from "@/components/loader/sprite-sheet-loader";
import { type FC } from "react";

export const AppInitLoader: FC = () => {
	return (
		<div className="w-screen h-screen flex flex-col justify-center items-center bg-gradient-to-br from-blue-50 to-indigo-100">
			<div className="flex flex-col items-center gap-6 p-8 bg-white/80 backdrop-blur-sm rounded-xl shadow-lg">
				<SpriteSheetLoader 
					size="large"
					speed={0.8}
					centered={false}
				/>
				<div className="text-indigo-700 text-2xl font-semibold tracking-wide">
					Loading Application...
				</div>
				<div className="text-gray-500 text-center">
					<span className="text-lg font-medium">
						Preparing your workspace
					</span>
					<span className="text-sm mt-2 block opacity-75">
						This may take a few moments
					</span>
				</div>
			</div>
		</div>
	);
};
